import { forwardRef, useCallback, useEffect, useState } from "react";
import { Rnd } from "react-rnd";
import { CardProps, useArtStore } from "../stateManagement/artZustand";
import { displayPic } from "../usePhotoGallery";
  
//export const ArtistiCard: React.FC<CardProps> = (props) => {
export const ArtistiCard = forwardRef<HTMLDivElement, CardProps>((props, ref) => {
  const [index, setIndex] = useState(props.index);
  const [width, setWidth] = useState(props.width);
  const [height, setHeight] = useState(props.height);
  const [x, setX] = useState(props.x || 0);
  const [y, setY] = useState(props.y || 0);
  const [fontSize, setFontSize] = useState(props.fontSize);
  const [mainBackgroundColor, setMainBackgroundColor] = useState(props.mainBackgroundColor);
  const [borderColor, setBorderColor] = useState(props.borderColor);
  const [textColor, setTextColor] = useState(props.textColor);
  const [labelBackgroundColor, setLabelBackgroundColor] = useState(props.labelBackgroundColor);
  const [borderSize, setBorderSize] = useState(props.borderSize);
  const [label, setLabel] = useState(props.label);
  const [image, setImage] = useState(props.image);
  const [isEditMode, setIsEditMode] = useState(props.isEditMode);
  const [loadRnd, setLoadRnd] = useState(false);
  const [isSelected, setIsSelected] = useState(false);
  const {cardsStates, selectedCards, setCardsStates, setSelectedCards} = useArtStore(); 
  

  useEffect(() => {
    // Introducing a small delay will fix the issue of
    // Wrong initial position calculation
    const timer = setTimeout(() => setLoadRnd(true), 500);
    return () => {
      clearTimeout(timer);
    };
  }, []);

  useEffect(() => {
    setFontSize(props.fontSize);
    setIsEditMode(props.isEditMode);
    setMainBackgroundColor(props.mainBackgroundColor);
    setBorderColor(props.borderColor);
    setTextColor(props.textColor);
    setLabelBackgroundColor(props.labelBackgroundColor);
    setBorderSize(props.borderSize);
    setLabel(props.label);
    setImage(props.image);
    setIndex(props.index);
    setX(props.x);
    setY(props.y);
    setWidth(props.width);
    setHeight(props.height);
    setIsSelected(selectedCards.includes(props.index));


    
  }, [selectedCards, props.x, props.y, props.width, props.height, props.index, props.fontSize, props.isEditMode, props.mainBackgroundColor, props.borderColor, props.textColor, props.labelBackgroundColor, props.borderSize, props.label, props.image]);

  


  const onResizeStop = useCallback((e: any, direction: any, ref: any, delta: any, position: any) => {
    /* Leave all above parameters even if not used !*/
    const newWidth = parseInt(ref.style.width, 10);
        const newHeight = parseInt(ref.style.height, 10);

        // Update the local state
        setWidth(newWidth);
        setHeight(newHeight);

        // Update the global state
        const updatedCardsStates = cardsStates.map((card, i) => {
            if (i === index) {
                return {
                    ...card,
                    width: newWidth,
                    height: newHeight
                };
            }
            return card;
        });
        setCardsStates(updatedCardsStates);
        props.setIsStored(false);
    
    
}, [index, cardsStates, setCardsStates]);

  // This will update the position of the card
  const onDragStop = useCallback((e: any, d: any) => {
    props.setIsStored(false);

    // Calculate the delta of movement.
    const deltaX = d.x - x;
    const deltaY = d.y - y;

    // Apply the delta to the dragged card.
    setX(d.x);
    setY(d.y);
    

    // Now, apply the same delta to all other selected cards.
    const newCardsStates = cardsStates.map((card, i) => {
      if(selectedCards.includes(i)){
        return {
          ...card,
          x: card.x + deltaX,
          y: card.y + deltaY
        };
      }else if(i === index){
        return {
          ...card,
          x: d.x,
          y: d.y
        };
      }
      return card;
      
    });
    setCardsStates(newCardsStates);


}, [x, y, index, width, height, fontSize, mainBackgroundColor, borderColor, textColor, labelBackgroundColor, borderSize, isSelected, label, image, isEditMode, cardsStates, selectedCards]);

  
console.log("EditMode:", isEditMode)
    if(!loadRnd) return null;
    return (
      loadRnd && <Rnd
      scale={1}
      position={{ x: x, y:y }}
      size={{ width, height: height || "auto" }}
      onResize={isEditMode ? undefined : onResizeStop}
      onDragStop={isEditMode ? undefined : onDragStop}
      enableResizing={{
        top: !isEditMode,
        right: !isEditMode,
        bottom: !isEditMode,
        left: !isEditMode,
        topRight: !isEditMode,
        bottomRight: !isEditMode,
        bottomLeft: !isEditMode,
        topLeft: !isEditMode
      }}
      disableDragging={isEditMode}
      //lockAspectRatio={true}
      bounds="parent"
      dragGrid={isEditMode ? [0,0] : [5, 5]}
      resizeGrid={isEditMode ? [0,0] : [5, 5]}
      onClick={() => {  if(isEditMode === true){
        // update selected cards (: (selectedCards: number[]) => void;)
        if(selectedCards.includes(index)){
          setSelectedCards(selectedCards.filter((i) => i !== index));
        } else {
          setSelectedCards([...selectedCards, index]);
        }

      }
    }
    }


      >
        <div 
        
        style={{ 
          border: isSelected ? `4px solid red` : '',
          boxSizing: 'border-box' // Ensures borders are included within the element's dimensions
        }}>     
          <div 
          ref={ref}
          style={{
                
                width: '100%',
                height: height || "auto",
                backgroundColor: mainBackgroundColor,
                border: `${borderSize}px solid ${borderColor}`,
                color: textColor,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center"
              }}>
                {displayPic(image, false, false, "100%", true)}

              <div style={{
                backgroundColor: labelBackgroundColor,
                padding: "5px",
                fontSize: fontSize }}>
                  {label}
              </div>
          </div>
        </div>
        
      </Rnd> 
    );
  });